<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics" class="w-full h-full flex">
    <DashcamPromoModal
      v-if="DASHCAM_PROMO_ENABLED"
      :active="dashcamPromoVisible"
      @update:active="(v) => (dashcamPromoVisible.value = v)"
      @close="closeDashcamPromo"
    />
    <Transition :name="modalPos ? 'slide-left' : 'slide-right'">
      <div
        v-if="modal"
        style="position: fixed; top: 0; height: 100vh; z-index: 999999"
        class="w-full sm:w-8/12 md:w-5/12"
        :style="[modalPos ? { left: 0 } : { right: 0 }]"
      >
        <vs-card
          class="cardx p-2"
          fixedHeight
          style="
            margin: 0;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          "
        >
          <div class="d-flex justify-content-between align-items-center pl-2">
            <!----><!---->
            <div class="truncate">
              <h5 class="mb-25">
                {{ selectedModal.name }}
              </h5>
            </div>
            <span
              class="flex justify-center items-center rounded-full relative overflow-hidden cursor-pointer"
              @click="modal = false"
              style="width: 45px; height: 45px"
            >
              <span class="b-avatar-custom relative">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                  />
                </svg>
              </span>
            </span>
          </div>
          <div style="max-height: 90vh" class="overflow-auto">
            <vs-list
              v-for="(step2, index2) of selectedModal.data"
              :key="index2"
            >
              <vs-row
                justify="center"
                v-if="step2 && selectedModal.name == 'Idling'"
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }} -
                    {{ 'Ignition ' + step2.ignition }} -
                    {{ 'Idling Time ' + step2.idlingStatus }} -
                    {{ 'Updated ' + step2.lastUpdated }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row
                justify="center"
                v-if="
                  step2 &&
                  selectedModal.name == 'Assets in Places of Interest (POI)'
                "
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }} -
                    {{ 'Ignition ' + step2.ignition }} -
                    {{ 'Idling Time ' + step2.idlingStatus }} -
                    {{ 'Updated ' + step2.lastUpdated }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row
                justify="center"
                v-if="step2 && selectedModal.name == 'Moving'"
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }} -
                    {{ 'Ignition ' + step2.ignition }} -
                    {{ 'Updated ' + step2.lastUpdated }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row
                justify="center"
                v-if="step2 && selectedModal.name == 'Refuels'"
              >
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }}</router-link
                  >
                  -
                  <a
                    target="_blank"
                    :href="`https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;&amp;q=${step2.coordinates}`"
                    ><b>{{
                      'Refuel ' +
                      step2.refuelVolume +
                      'L' +
                      ' at ' +
                      step2.refuelTime
                    }}</b></a
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
              <vs-row justify="center" v-else>
                <vs-col>
                  <router-link
                    :to="'/map-single/' + step2.assetId + '/' + step2.assetName"
                    >{{ step2.assetName }}</router-link
                  >
                </vs-col>
                <vs-col> </vs-col>
              </vs-row>
            </vs-list>
          </div>
        </vs-card>
      </div>
    </Transition>
    <vs-progress
      class="absolute top-0 left-0"
      indeterminate
      color="primary"
      v-if="isLoading"
    ></vs-progress>
    <div v-if="statsError && !isLoading" class="dashboard-error-banner">
      <span>Failed to load dashboard data. Retrying&hellip;</span>
    </div>
    <layout v-if="dashboardConfig.showAnalytics">
      <template #top>
        <vs-card
          class="cardx lg:flex-1 lg:h-full md:w-5/12 w-full"
          style="margin: 0"
        >
          <h4>Fleet Status</h4>
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="donut"
                :options="movementChartOptions"
                :series="movementChartSeries"
                height="220"
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  icon="near_me"
                  subtitle="Move"
                  :title="movementChartSeries[0]"
                  style="color: #28c76f"
                ></vs-list-item>
                <vs-list-item
                  icon="pause_circle"
                  subtitle="Idle"
                  :title="movementChartSeries[1]"
                  style="color: #ff9f43"
                ></vs-list-item>
                <vs-list-item
                  icon="stop_circle"
                  subtitle="Park"
                  :title="movementChartSeries[2]"
                  style="color: #ea5455"
                ></vs-list-item>
                <vs-list-item
                  icon="signal_wifi_bad"
                  subtitle="Inactive"
                  :title="movementChartSeries[3]"
                  style="color: #b4a5a5"
                ></vs-list-item>
              </vs-list>
            </vs-col>
          </vs-row>
        </vs-card>
        <vs-card
          class="cardx lg:flex-1 lg:h-full md:w-5/12 w-full"
          style="margin: 0"
        >
          <h4>Temperature</h4>
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="donut"
                :options="spikeChartOptions"
                :series="spikeChartSeries"
                height="220"
                @click="
                  (event, chartContext, config) => {
                    getSpikeData(!config.dataPointIndex ? 'normal' : 'spike');
                  }
                "
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  icon="thermostat"
                  subtitle="Normal"
                  :title="spikeChartSeries[0]"
                  style="color: #28c76f; cursor: pointer"
                  @click.native="getSpikeData('normal')"
                ></vs-list-item>
                <vs-list-item
                  icon="thermostat"
                  subtitle="Spike"
                  :title="spikeChartSeries[1]"
                  style="color: #ea5455; cursor: pointer"
                  @click.native="getSpikeData('spike')"
                ></vs-list-item>
              </vs-list>
              <vs-popup
                class="holamundo"
                :title="
                  String(spikeDataModalData).charAt(0).toUpperCase() +
                  String(spikeDataModalData).slice(1)
                "
                :active.sync="spikeDataModal"
              >
                <vs-table
                  v-if="spikeDataModalData"
                  :data="spikeData[spikeDataModalData]"
                  stripe
                >
                  <template slot="thead">
                    <vs-th> No </vs-th>
                    <vs-th> Name </vs-th>
                    <vs-th> Current Temp </vs-th>
                    <vs-th> Preferred Temp </vs-th>
                    <vs-th> Time</vs-th>
                    <vs-th> Action</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <span>
                          <b>{{ indextr + 1 }}</b></span
                        >
                      </vs-td>
                      <vs-td
                        v-for="(td, indextd) in [
                          'assetName',
                          'currentTemp',
                          'preferredTemp',
                          'time',
                        ]"
                        :data="tr"
                        :key="td"
                      >
                        {{ data[indextr][td] }}
                      </vs-td>

                      <vs-td>
                        <vs-button
                          @click.native="goToAsset(tr)"
                          color="primary"
                          type="border"
                          icon="monitor"
                        ></vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </vs-popup>
            </vs-col>
          </vs-row>
        </vs-card>
        <vs-card
          class="cardx lg:flex-1 lg:h-full md:w-5/12 w-full"
          style="margin: 0"
        >
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
              <h4>Fleet Usage (KM)</h4>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
            </vs-col>
          </vs-row>

          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="bar"
                height="220"
                :options="mileageChartOptions"
                :series="mileageSeries"
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  subtitle="Usage Last 24hrs"
                  :title="mileageData[2] + ' km'"
                ></vs-list-item>
                <vs-list-item
                  subtitle="Overall Usage"
                  :title="mileageData[0] + ' km'"
                ></vs-list-item>
                <vs-list-item
                  subtitle="Average per Asset"
                  :title="mileageData[1] + ' km'"
                ></vs-list-item>
              </vs-list>
            </vs-col>
          </vs-row>
        </vs-card>

        <vs-card
          class="cardx m-0 flex flex-col justify-between lg:flex-1 lg:h-full md:w-5/12 w-full"
        >
          <h4>Fleet Idle</h4>
          <br />
          <div class="flex flex-col gap-8 flex-grow h-full items-stretch mt-4">
            <div
              class="d-flex justify-content-between mb-1"
              v-for="(n, i) in [
                'Current Idle Time',
                'Approx Fuel Waste',
                'Approx Fuel Waste Cost',
              ]"
              :key="n"
            >
              <div class="series-info flex items-center">
                <span
                  class="flex justify-center items-center rounded-full relative overflow-hidden"
                  style="width: 45px; height: 45px"
                >
                  <div
                    class="h-full w-full bg-danger absolute opacity-25"
                  ></div>
                  <span class="b-avatar-custom relative">
                    <component :is="`Icon${n.replace(/\s/g, '')}`" />
                  </span>
                </span>
                <h4 class="font-weight-bolder ml-4 mb-0" style="color: #ff9f43">
                  {{ n }}
                </h4>
              </div>
              <div class="h-full w-48 flex items-center justify-end mb-0">
                <h5>
                  <span v-if="i == 2">RM</span> {{ idleStat[i] }}
                  <span v-if="i != 2">{{ ['hours', 'liters'][i] }}</span>
                </h5>
              </div>
            </div>
          </div>
        </vs-card>
      </template>

      <template #mid>
        <vs-card
          class="cardx m-0 lg:flex-1 lg:h-full sm:w-5/12 h-48 w-full"
          v-for="(n, i) in [
            'Overspeeding',
            'Backup Battery Alert',
            'Unauthorized Ignition',
            'Immobilizer',
          ]"
          :key="i"
        >
          <h4>{{ n }}</h4>
          <div
            class="card-body d-flex justify-content-between align-items-center pl-2"
          >
            <!----><!---->
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder" style="color: #ff9f43">
                {{ alarmData[i] + ' times' }}
              </h2>
              <span>Last 12 hrs</span>
              <span v-if="i == 0"> - Over 80kph</span>
            </div>
            <span
              class="flex justify-center items-center rounded-full relative overflow-hidden"
              style="width: 45px; height: 45px"
            >
              <div class="h-full w-full bg-danger absolute opacity-25"></div>
              <span class="b-avatar-custom relative">
                <component :is="`Icon${n.replace(/\s/g, '')}`" />
              </span>
            </span>
          </div>
        </vs-card>
      </template>

      <template #bot>
        <vs-card
          class="cardx m-0 w-full md:w-5/12"
          fixedHeight
          v-for="(n, i) in [
            { name: 'Assets in Places of Interest (POI)', data: locationStat },
            {
              name: 'Moving / Idling / Refuels ',
              data: [
                { name: 'Moving', data: longStatMovement },
                { name: 'Idling', data: longStatIdle },
                { name: 'Refuels', data: refuelStat },
              ],
            },
          ]"
          :key="i"
        >
          <h4>{{ n.name }}</h4>
          <div style="max-height: 320px" class="overflow-auto w-full mt-8">
            <div
              v-for="(step, index) of n.data"
              :key="index"
              class="cursor-pointer hover:bg-grey py-1"
              @click="
                modal = true;
                i == 1
                  ? step.data.length == 0
                    ? (modal = false)
                    : void 0
                  : void 0;
                selectedModal = i == 0 ? { name: index, data: step } : step;
                modalPos = i == 0 ? false : true;
              "
            >
              <div
                class="d-flex justify-content-between align-items-center pl-2"
              >
                <!----><!---->
                <div class="truncate" v-if="index != 2">
                  <h5 class="mb-25" v-if="i == 0">
                    {{ index }} ({{ step.length }} assets)
                  </h5>
                  <h5 class="mb-25" v-if="i == 1 && step.data.length != 0">
                    {{ step.name }} (

                    {{ step.data.length }}
                    assets)
                  </h5>
                  <!-- <h5 class="mb-25">{{ index }} ({{ step.length }} assets)</h5> -->
                </div>
                <div class="truncate" v-if="index == 2">
                  <h5 class="mb-25" v-if="i == 0">
                    {{ index }} ({{ step.length }} times)
                  </h5>
                  <h5 class="mb-25" v-if="i == 1 && step.data.length != 0">
                    {{ step.name }} (

                    {{ step.data.length }}
                    times)
                  </h5>
                  <!-- <h5 class="mb-25">{{ index }} ({{ step.length }} assets)</h5> -->
                </div>
                <span
                  class="flex justify-center items-center rounded-full relative overflow-hidden"
                  style="width: 45px; height: 45px"
                >
                  <span class="b-avatar-custom relative"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M11 17h2v-6h-2v6Zm1-8q.425 0 .713-.288T13 8q0-.425-.288-.713T12 7q-.425 0-.713.288T11 8q0 .425.288.713T12 9Zm0 13q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Zm0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20Zm0-8Z"
                      />
                    </svg>
                  </span>
                </span>
              </div>
              <vs-divider class="m-0" />
            </div>
          </div>
        </vs-card>
      </template>
    </layout>

    <div
      v-else
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="page-login"
    >
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card>
          <div
            style="min-height: 505px"
            class="flex flex-col justify-center items-center w-full h-full"
          >
            <h1 class="text-4xl font-bold text-primary">Welcome to</h1>

            <img
              id="loading-logo"
              src="https://fleets.igeotechgps.com/logo.png"
              alt="Logo"
              height="100"
              class="mb-8"
            />
          </div>
        </vx-card>
      </div>
    </div>

    <div
      class="absolute top-0 right-0 flex p-2 gap-2 items-center"
      style="min-height: 50px; z-index: 888"
    >
      <q-button
        class="p-1 w-full h-full border-none rounded shadow"
        :color="dashboardConfig.showAnalytics ? 'primary' : 'secondary'"
        icon="analytics"
        @click="dashboardConfig.showAnalytics = !dashboardConfig.showAnalytics"
      >
        <q-tooltip content-class="bg-primary">
          Set your default view for live tracking
        </q-tooltip>
      </q-button>
    </div>

    <!-- Dashcam promo button - bottom -->
    <div
      v-if="DASHCAM_PROMO_ENABLED"
      class="dashcam-promo-trigger"
      role="button"
      tabindex="0"
      @click="openDashcamPromo"
      @keydown.enter="openDashcamPromo"
      @keydown.space.prevent="openDashcamPromo"
    >
      <img :src="imgDashcamPromo" alt="Dashcam with MDVR" class="dashcam-promo-trigger-img" />
      <div class="dashcam-promo-trigger-text">
        <span class="dashcam-promo-trigger-title">Introducing Dashcam with MDVR</span>
        <span class="dashcam-promo-trigger-cta">Click to open</span>
      </div>
    </div>

  </div>
</template>

<script setup>
import QButton from '../experimental/playback/QButton.vue';
import DashcamPromoModal from './DashcamPromoModal.vue';
import imgDashcamPromo from './promo_assets/image_slide2_2.png';
import { ref, reactive, onMounted, onBeforeUnmount, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router/composables';
import axios from '@/axios.js';
import {
  trackingAssetIds,
  trackingUnitIds,
  remapShadowDashboardData,
} from '@/utils/shadowUnit.js';

import Layout from './Layout.vue';
import VueApexCharts from 'vue-apexcharts';
import IconOverspeeding from './IconOverspeeding.vue';
import IconBackupBatteryAlert from './IconBackupBatteryAlert.vue';
import IconImmobilizer from './IconImmobilizer.vue';
import IconUnauthorizedIgnition from './IconUnauthorizedIgnition.vue';
import IconCurrentIdleTime from './IconCurrentIdleTime.vue';
import IconApproxFuelWaste from './IconApproxFuelWaste.vue';
import IconApproxFuelWasteCost from './IconApproxFuelWasteCost.vue';

// -------------------------------------------------------------------------------------
// state
// -------------------------------------------------------------------------------------
const DASHCAM_PROMO_ENABLED = false;
const DASHCAM_PROMO_STORAGE_KEY = 'igt_dashcam_promo_last_seen';
const DASHCAM_PROMO_INTERVAL_MS = 24 * 60 * 60 * 1000; // 24 hours
const DASHBOARD_CACHE_KEY = 'igt_dashboard_cache';
const DASHBOARD_CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes
const dashcamPromoVisible = ref(false);
const modal = ref(false);
const modalPos = ref(false);
const selectedModal = ref(null);

const userInfo = ref(JSON.parse(localStorage.getItem('userInfo')));
const unitSelection = ref(JSON.parse(localStorage.getItem('unitSelection')));
const allUnits = ref(JSON.parse(localStorage.getItem('allUnits')));
const geoPOIData = ref(JSON.parse(localStorage.getItem('geoPOIData')));

const locationStat = ref([]);
const alarmData = ref([0, 0, 0, 0]);
const tableListener = ref(null);
const longStatMovement = ref([]);
const isLoading = ref(true);
const statsError = ref(false);
const longStatIdle = ref([]);
const refuelStat = ref([]);

const mileageSeries = ref([
  {
    name: 'Usage Last 24 hours (km)',
    data: [0, 0, 0, 0, 0],
  },
]);
const mileageData = ref([0, 0, 0]);
const idleStat = ref([0, 0, 0]);

const movementChartSeries = ref([0, 0, 0, 0]);
const movementChartOptions = reactive({
  chart: {
    height: 200,
    type: 'radialBar',
  },
  colors: ['#28C76F', '#FF9F43', '#EA5455', '#b4a5a5'],
  labels: ['Move', 'Idle', 'Park', 'Inactive'],
  legend: {
    show: false,
  },
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
          },
        },
      },
    },
  },
});

const spikeData = ref(null);
const spikeDataModal = ref(false);
const spikeDataModalData = ref(null);
const spikeChartSeries = ref([0, 0, 0, 0]);
const spikeChartOptions = reactive({
  chart: {
    height: 200,
    type: 'radialBar',
  },
  colors: ['#28C76F', '#EA5455'],
  labels: ['Normal', 'Spike'],
  legend: {
    show: false,
  },
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
          },
        },
      },
    },
  },
});

const mileageChartOptions = reactive({
  chart: {
    type: 'bar',
    height: 200,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      borderRadius: 4,
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ['', '', '', '', ''],
    title: {
      text: 'Top Usage',
    },
  },
});

// -------------------------------------------------------------------------------------
// utilities
// -------------------------------------------------------------------------------------
const router = useRouter();

// -------------------------------------------------------------------------------------
// methods
// -------------------------------------------------------------------------------------
function openDashcamPromo() {
  if (!DASHCAM_PROMO_ENABLED) return;
  dashcamPromoVisible.value = true;
}

function closeDashcamPromo() {
  dashcamPromoVisible.value = false;
  try {
    localStorage.setItem(DASHCAM_PROMO_STORAGE_KEY, String(Date.now()));
  } catch (e) {
    console.warn('localStorage not available', e);
  }
}

function getSpikeData(type) {
  if (!spikeData.value) return;
  spikeDataModal.value = true;
  spikeDataModalData.value = type;
}

function goToAsset(tr) {
  const routeData = router.resolve({
    name: 'monitor',
    params: { assetId: tr.assetId, assetName: tr.assetName, view: 'map' },
  });
  window.open(routeData.href, '_blank');
}

function applyStatsData(d) {
  spikeData.value = d.spikeData;
  movementChartSeries.value = d.stat;
  spikeChartSeries.value = d.spikeStat || [0, 0, 0, 0];
  locationStat.value = d.locationStat;
  longStatIdle.value = d.longStatIdle;
  longStatMovement.value = d.longStatMovement;
  refuelStat.value = d.refuelStat;
  mileageChartOptions.xaxis.categories = d.mileageSeriesLabel;
  mileageSeries.value = [{ name: 'Usage Last 24 hours (km)', data: d.mileageSeries }];
  mileageData.value = d.mileageData;
  idleStat.value = d.idleStat;
  alarmData.value = d.alarmData;
}

function loadFromCache() {
  try {
    const raw = localStorage.getItem(DASHBOARD_CACHE_KEY);
    if (!raw) return false;
    const cached = JSON.parse(raw);
    const uid = userInfo.value && userInfo.value.uid;
    if (!cached || cached.uid !== uid) return false;
    if (Date.now() - cached.ts > DASHBOARD_CACHE_TTL_MS) return false;
    applyStatsData(cached.data);
    return true;
  } catch {
    return false;
  }
}

function saveToCache(data) {
  try {
    const uid = userInfo.value && userInfo.value.uid;
    localStorage.setItem(DASHBOARD_CACHE_KEY, JSON.stringify({ uid, ts: Date.now(), data }));
  } catch {
    /* localStorage full or unavailable */
  }
}

function scheduleNextRefresh() {
  if (tableListener.value) {
    clearTimeout(tableListener.value);
    tableListener.value = null;
  }
  tableListener.value = setTimeout(() => { getStats(); }, DASHBOARD_CACHE_TTL_MS);
}

async function getStats() {
  if (tableListener.value) {
    clearTimeout(tableListener.value);
    tableListener.value = null;
  }
  isLoading.value = true;
  statsError.value = false;
  try {
    const selectedUnits = trackingAssetIds(allUnits.value || []);
    const selectedUnits2 = Array.from(
      new Set(trackingUnitIds((unitSelection.value || []).map((e) => e.unitId))),
    );

    const res = await axios.post('chartsWebv2/' + userInfo.value.uid, {
      selectedUnits,
      selectedUnits2,
      geoPOIData: geoPOIData.value,
      fuelPrice: (userInfo.value && userInfo.value.fuelPrice) || 2.15,
    });

    if (res.status === 200 && res.data.success) {
      const data = remapShadowDashboardData(res.data, unitSelection.value);
      applyStatsData(data);
      saveToCache(data);
    }
  } catch (err) {
    console.error('[Dashboard] getStats failed:', err);
    statsError.value = true;
  } finally {
    isLoading.value = false;
    scheduleNextRefresh();
  }
}

// -------------------------------------------------------------------------------------
// lifecycle
// -------------------------------------------------------------------------------------

import { useStorage } from '@vueuse/core';

const dashboardConfig = useStorage('igt_dashboard_config', {
  showAnalytics: true,
});

watch(
  () => dashboardConfig.value.showAnalytics,
  async (show) => {
    if (show) {
      const cacheHit = loadFromCache();
      if (cacheHit) {
        scheduleNextRefresh();
      } else {
        await getStats();
      }
    } else if (tableListener.value) {
      clearTimeout(tableListener.value);
      tableListener.value = null;
    }
  },
);

onMounted(async () => {
  try {
    // Promo code kept but hard-disabled for this deployment.
    if (DASHCAM_PROMO_ENABLED) {
      const checkShouldShowDashcamPromo = () => {
        try {
          const lastSeen = localStorage.getItem(DASHCAM_PROMO_STORAGE_KEY);
          const now = Date.now();
          if (!lastSeen) {
            dashcamPromoVisible.value = true;
            return;
          }
          const lastSeenTime = parseInt(lastSeen, 10);
          if (isNaN(lastSeenTime) || now - lastSeenTime >= DASHCAM_PROMO_INTERVAL_MS) {
            dashcamPromoVisible.value = true;
          }
        } catch (e) {
          console.warn('Promo localStorage check failed', e);
        }
      };
      requestAnimationFrame(() => {
        setTimeout(checkShouldShowDashcamPromo, 300);
      });
    }

    await nextTick();

    let statsPromise = Promise.resolve();
    if (dashboardConfig.value.showAnalytics) {
      const cacheHit = loadFromCache();
      if (cacheHit) {
        isLoading.value = false;
        scheduleNextRefresh();
      } else {
        statsPromise = getStats();
      }
    }

    const selectionPromise = (userInfo.value && userInfo.value.uid)
      ? axios.post(
          'clients/getSelection/' + userInfo.value.uid + '/Web',
          { userInfo: userInfo.value },
        ).then((response) => {
          if (response.status === 200 && response.data.success) {
            localStorage.setItem('allUnits', JSON.stringify(response.data.allUnits));
            localStorage.setItem('unitSelection', JSON.stringify(response.data.unitSelection));
            localStorage.setItem('cctvSelection', JSON.stringify(response.data.cctvSelection || []));
            localStorage.setItem('cctvUnits', JSON.stringify(response.data.cctvUnits || []));
            localStorage.setItem('mapPOIData', JSON.stringify(response.data.mapPOIData));
            localStorage.setItem('geoPOIData', JSON.stringify(response.data.geoPOIData));
            localStorage.setItem('userInfo', JSON.stringify(response.data.userInfo));

            allUnits.value = response.data.allUnits;
            unitSelection.value = response.data.unitSelection;
            geoPOIData.value = response.data.geoPOIData;
            userInfo.value = response.data.userInfo;
          }
        })
      : Promise.resolve();

    await Promise.all([statsPromise, selectionPromise]);
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
});

onBeforeUnmount(() => {
  if (tableListener.value) {
    clearTimeout(tableListener.value);
  }
});
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

.cardx {
  padding: 0.5rem;
}
td .tooltip {
  position: absolute;
}

.dashcam-promo-trigger {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 888;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.dashcam-promo-trigger:hover {
  transform: translateX(-50%) translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.4);
}
.dashcam-promo-trigger-img {
  width: 72px;
  height: 54px;
  object-fit: cover;
  border-radius: 8px;
}
.dashcam-promo-trigger-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.dashcam-promo-trigger-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
  line-height: 1.3;
}
.dashcam-promo-trigger-cta {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 0.15rem;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s ease;
}
.slide-left-enter,
.slide-left-leave-to {
  transform: translateX(-100%);
}
.slide-right-enter,
.slide-right-leave-to {
  transform: translateX(100%);
}

.dashboard-error-banner {
  position: absolute;
  top: 4px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 900;
  background: #ea5455;
  color: #fff;
  padding: 0.35rem 1.25rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(234, 84, 85, 0.35);
}

@media (max-width: 640px) {
  .dashcam-promo-trigger {
    display: none;
  }
}

/*! rtl:end:ignore */
</style>
